import React, { useState, useEffect, useMemo } from "react";
import "~pages/PricesTableV2/components/Tabela/style.scss";
import { useNavigate } from "react-router-dom";
import FiltroNegociacoes from "~pages/PricesTableV2/components/filters/FiltroNegociacoes";
import ResponseEnvioNegociacao from "~pages/PricesTableV2/components/Modal/ResponseEnvioNegociacao";
import LazyModalWrapper from "~pages/PricesTableV2/components/Modal/LazyModalWrapper";
import InformacoesAdicionaisModal from "~pages/PricesTableV2/components/Modal/InformacoesAdicionaisModal";
import PricesTableSolicitarNegociacaoModal from "~pages/PricesTableV2/components/Modal/SolicitarNegociacaoModal";
import ExcluirNegociacao from "~pages/PricesTableV2/components/Modal/ExcluirNegociacao";
import ModalResponse from "~components/Modal/ModalResponse";
import ModalErroNegociacao from "~pages/PricesTableV2/components/Modal/ModalErroNegociacao";
import LoaderFull from "~components/Form/components/LoaderFull";
import ContainerDoPrecoCliente from "~pages/PricesTableV2/components/Tabela/ContainerDoPrecoCliente";
import useModal from "~components/Modal/hooks/useModal";
import { initialPath } from "~misc/paths";
import { getCodigoExternos } from "~services/GlobalServices";
import apiGenericClient from "~services/utils/apiGenericClient";
import useUnsavedChangesWarningTable from "~components/Form/hooks/useUnsavedChangesWarningTable";
import usePrecoCliente from "~/fetchs/usePrecoCliente";
import { FormProvider, useForm } from "react-hook-form";
import { getStoragekeysNegociations } from "~pages/PricesTableV2/helpers/storage";
import { useConfigureFooter } from "~hooks/useHelpers";
import TabelaDePrecoSubmit from "~pages/PricesTableV2/components/Footer/TabelaDePrecoSubmit";
import { TableStateProvider, useTableState } from "~pages/PricesTableV2/context/TableStateContext";
import { renovarNegociacao } from "~pages/PricesTableV2/hooks/PricesTableServices";
import { SaveIndexBD } from "~services/utils/SaveIndexBD";

const AllNegotiationsContent = () => {
  const [tableKey] = useState(1);
  const { isFormDirty, clearAll, alteracoes } = useTableState();

  useEffect(() => {
    clearAll();
  }, [clearAll]);

  const [loading, setLoading] = useState(false);
  const [isOpenInformacoesAdicionaisAlteracaoModal, setIsOpenInformacoesAdicionaisAlteracaoModal] = useState(false);
  const [showResponseAlert, setShowResponseAlert] = useState(false);
  const [showResponseAlertError, setShowResponseAlertError] = useState(false);
  const [showResponseErrorMsg, setShowResponseErrorMsg] = useState('');
  const [modalErros, setModalErros] = useState([]);
  const [showResponseMsg, setShowResponseMsg] = useState({
    message: "Condições comerciais enviadas com sucesso para portal com motivo de RENOVAÇÃO",
    alerts: []
  });
  const [skip, setSkip] = useState(0);
  const [take] = useState(10);
  const [dadosHeader, setDadosHeader] = useState({});
  const [dadosDelete, setDadosDelete] = useState(null);
  const [responseDelete, setResponseDelete] = useState({
    isOpen: false,
    message: "Envio de exclusão feito com sucesso!",
    link: null,
  });
  const [precosRegraData, setPrecosRegraData] = useState(null);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const navigate = useNavigate();

  const { isModalOpen, closeModal, setModalOpen } = useModal();
  const {
    isModalOpen: isExcluirModalOpenPreco,
    closeModal: closeExcluirModalPreco,
    setModalOpen: setExcluirModalOpenPreco,
  } = useModal();

  const onSuccessAlteracao = (response) => {
    setLoading(false);
    clearAll();
    if (response?.isOffline) {
      setIsOpenInformacoesAdicionaisAlteracaoModal(false);
      setShowResponseMsg({
        message: `Condições comerciais armazenadas offline para portal e serão enviadas para o servidor assim que a conexão estiver estabelecida`,
        alerts: []
      });
      setShowResponseAlert(true);
      return;
    }

    if (response?.errosEnvio?.length) {
      setIsOpenInformacoesAdicionaisAlteracaoModal(false);
      setModalErros(response.errosEnvio || []);
      setShowResponseAlertError(true);
      if (response?.renovacoesNegociacoes?.length > 0) {
        const codigosExternos = getCodigoExternos(response.renovacoesNegociacoes);
        setShowResponseMsg({ message: `Condições comerciais enviadas com sucesso para portal com motivo de ALTERAÇÃO DE FAIXA ${codigosExternos}`, alerts: [] });
        setShowResponseAlert(true);
      }
      return;
    }

    const codigosExternos = getCodigoExternos(response?.renovacoesNegociacoes);
    setIsOpenInformacoesAdicionaisAlteracaoModal(false);
    setShowResponseMsg({ message: `Condições comerciais enviadas com sucesso para portal com motivo de ALTERAÇÃO DE FAIXA ${codigosExternos}`, alerts: [] });
    setShowResponseAlert(true);
  };

  const onAlteracaoError = (response) => {
    setLoadingSearch(false);
    setShowResponseAlertError(true);
    setIsOpenInformacoesAdicionaisAlteracaoModal(false);
    setShowResponseErrorMsg(response.message || 'Ocorreu um erro ao tentar alterar negociação!');
  };


  const handleAltualizar = () => {
    setIsOpenInformacoesAdicionaisAlteracaoModal(true);
  };

  const handleAddButton = (grupoProdutoId, produtoId, filialId, clienteId, origem) => {
    const dadosHeader = { grupoProdutoId, produtoId, filialId, clienteId, origem };

    if (origem === "editar" && clienteId) {
      SaveIndexBD("dados-selecionados-negociacao", dadosHeader);
      navigate(`${initialPath}/tabela-preco/${clienteId}/editar-negociacao`);
      return;
    }

    setModalOpen(true);
    setDadosHeader(dadosHeader);
  };

  const handleDeleteButton = (_, item) => {
    setExcluirModalOpenPreco(true);
    setPrecosRegraData(item);
  };

  const handleDelete = () => {
    setLoading(true);
    excluirPreco();
  };

  const onSucessDeletar = (response) => {
    setLoading(false);

    if (response?.isOffline) {
      closeExcluirModalPreco();
      setResponseDelete({
        isOpen: true,
        message:
          "Envio de exclusão feito offline e será enviada para o servidor assim que a conexão estiver estabelecida com sucesso!",
        link: `${initialPath}/tabela-preco/`,
      });
      return;
    }
    if (Array.isArray(response)) {
      const error = response.find((res) => res.status === "Error");
      if (error) {
        closeExcluirModalPreco();
        setResponseDelete({ isOpen: true, message: error?.mensagem, link: null, status: "warning" });
        return;
      }
    }
    closeExcluirModalPreco();
    setResponseDelete({
      isOpen: true,
      message: "Envio de exclusão feito com sucesso!",
      link: `${initialPath}/tabela-preco/`,
    });
  };

  const onErrorDeletar = () => {
    setLoading(false);
    closeExcluirModalPreco();
    setResponseDelete({
      isOpen: true,
      message: "Ocorreu um erro ao tentar deletar preço!",
      link: null,
      status: "warning",
    });
  };

  const excluirPreco = async () => {
    if (dadosDelete?.length > 0) {
      closeExcluirModalPreco();
      const client = new apiGenericClient("simulacao", "/api/PortalAprovacao/DeletarPreco/");
      const response = await client.createData(dadosDelete);
      return response?.data === undefined ? onErrorDeletar() : onSucessDeletar(response.data);
    }

    setLoading(false);
    return {};
  };

  const handleSubmitAltercao = async (dados) => {
    if ((alteracoes || []).length > 0) {
      dados.alteracoes = alteracoes;
    }

    setLoading(true);
    setIsOpenInformacoesAdicionaisAlteracaoModal(false);

    try {
      const response = await renovarNegociacao(dados);
      if (response.isSuccess != undefined && response.isSuccess === false)
        onAlteracaoError(response);
      else
        onSuccessAlteracao(response);
    } finally {
      setLoading(false);
    }
  };

  const onCloseAlert = () => {
    navigate(`${initialPath}/tabela-preco/minhas-solicitacoes`);
  };

  useConfigureFooter(
    {
      hideHomeButton: false,
      buttonsComponent: isFormDirty ? <TabelaDePrecoSubmit handleSubmit={handleAltualizar} /> : null,
    },
    [isFormDirty]
  );

  useUnsavedChangesWarningTable(isFormDirty, navigate, "Voltar");

  const keys = useMemo(() => getStoragekeysNegociations("allNegotiations"), []);

  const getDefaultValues = () => {
    try {
      const savedCliente = localStorage.getItem(keys.cliente);
      const savedProduto = localStorage.getItem(keys.produto);
      const savedGrupoProduto = localStorage.getItem(keys.grupoProduto);
      const savedFilial = localStorage.getItem(keys.filiais);
      const savedNegociacao = localStorage.getItem(keys.negociacao);
      const savedPeriodo = localStorage.getItem(keys.periodo);

      return {
        cliente: savedCliente ? JSON.parse(savedCliente).value : 0,
        grupoProduto: savedGrupoProduto ? JSON.parse(savedGrupoProduto).value : 0,
        produto: savedProduto ? JSON.parse(savedProduto).value : 0,
        filial: savedFilial ? JSON.parse(savedFilial).value : 0,
        tipoSolicitacao: savedNegociacao ? JSON.parse(savedNegociacao).value : 0,
        ordem: "recentes",
        statusSolicitacao: 0,
        periodo: savedPeriodo ? JSON.parse(savedPeriodo) : { value: 0, label: "Todos", startDate: null, endDate: null },
      };
    } catch (error) {
      console.warn("Error loading filters from localStorage:", error);
      return {
        cliente: 0,
        grupoProduto: 0,
        produto: 0,
        filial: 0,
        tipoSolicitacao: 0,
        ordem: "recentes",
        statusSolicitacao: 0,
        periodo: { value: 0, label: "Todos", startDate: null, endDate: null },
      };
    }
  };

  const methods = useForm({
    defaultValues: getDefaultValues(),
  });

  const cliente = methods.watch("cliente");
  const grupoProduto = methods.watch("grupoProduto");
  const produto = methods.watch("produto");
  const filial = methods.watch("filial");
  const tipoSolicitacao = methods.watch("tipoSolicitacao");
  const ordem = methods.watch("ordem");
  const periodo = methods.watch("periodo");

  const filters = useMemo(
    () => ({
      cliente: cliente || 0,
      grupoProduto: grupoProduto || 0,
      produto: produto || 0,
      filial: filial || 0,
      tipoSolicitacao: tipoSolicitacao || 0,
      ordem: ordem || "recentes",
      periodo: periodo?.value || 0,
      startDate: periodo?.startDate || null,
      endDate: periodo?.endDate || null,
    }),
    [cliente, grupoProduto, produto, filial, tipoSolicitacao, ordem, periodo]
  );

  const { precosCliente, total, totalRenderizado, clientesDisponiveis } = usePrecoCliente({
    filters,
    skip,
    take,
    setLoading: setLoadingSearch,
    onlyVigenciaVencendo: false,
    id: 0,
    microrregiao: undefined,
    cluster: undefined,
  });

  return (
    <FormProvider {...methods}>
      <form>
        <FiltroNegociacoes
          nomeDoFiltro="allNegotiations"
          clientesDisponiveis={clientesDisponiveis}
          hideSelectAll
          useCustomOrder
          filters={filters}
        />

        <ContainerDoPrecoCliente
          loadingSearch={loadingSearch}
          handleAddButton={handleAddButton}
          handleDeleteButton={handleDeleteButton}
          filters={filters}
          tableKey={tableKey}
          onlyVencimento={false}
          precosCliente={precosCliente}
          take={take}
          setSkip={setSkip}
          totalRenderizado={totalRenderizado}
          total={total}
          showCheckboxes={false}
        />

        {isOpenInformacoesAdicionaisAlteracaoModal && (
          <LazyModalWrapper>
            <InformacoesAdicionaisModal
              isOpen={isOpenInformacoesAdicionaisAlteracaoModal}
              onClose={() => {
                setIsOpenInformacoesAdicionaisAlteracaoModal(false);
              }}
              handleSubmit={handleSubmitAltercao}
              submitLabel={"Salvar Massivo"}
            />
          </LazyModalWrapper>
        )}

        {isModalOpen && (
          <LazyModalWrapper>
            <PricesTableSolicitarNegociacaoModal
              isOpen={isModalOpen}
              closeModal={closeModal}
              dadosHeader={dadosHeader}
            />
          </LazyModalWrapper>
        )}

        <ResponseEnvioNegociacao
          fixed
          show={showResponseAlert}
          setShow={setShowResponseAlert}
          text={showResponseMsg?.message || ''}
          alerts={showResponseMsg?.alerts || ''}
          onClose={onCloseAlert}
        />

        {showResponseAlertError && modalErros.length > 0 && (
          <ModalErroNegociacao
            isOpen={showResponseAlertError}
            erros={modalErros}
            closeModal={() => { setShowResponseAlertError(false); setModalErros([]); }}
          />
        )}
        {showResponseAlertError && modalErros.length === 0 && (
          <ModalResponse
            isOpen={showResponseAlertError}
            status={"warning"}
            message={showResponseErrorMsg}
            closeModal={() => setShowResponseAlertError(false)}
            link={null}
          />
        )}

        {isExcluirModalOpenPreco && (
          <LazyModalWrapper>
            <ExcluirNegociacao
              isOpen={isExcluirModalOpenPreco}
              onClose={closeExcluirModalPreco}
              data={precosRegraData}
              onConfirm={handleDelete}
              mensagem={`Escolha qual negociação você deseja excluir:`}
              setSelected={setDadosDelete}
              loading={loading}
            />
          </LazyModalWrapper>
        )}

        {responseDelete?.isOpen && (
          <LazyModalWrapper>
            <ModalResponse
              isOpen={responseDelete?.isOpen}
              status={responseDelete?.status || "success"}
              message={responseDelete?.message || "Operação realizada com sucesso!"}
              closeModal={() => setResponseDelete({ isOpen: false, message: "", link: null })}
              link={responseDelete.link ? responseDelete.link : null}
            />
          </LazyModalWrapper>
        )}

        {loading && (
          <div className="spinner__form">
            <LoaderFull />
          </div>
        )}
      </form>
    </FormProvider>
  );
};

const AllNegotiations = () => {
  return (
    <TableStateProvider>
      <AllNegotiationsContent />
    </TableStateProvider>
  );
};

export default AllNegotiations;
